import { tools } from '../../utils';
export function authHeader () {
    // return authorization header with jwt token
    // let user = JSON.parse(localStorage.getItem('user'));
    let token;
    if (tools.canUseDOM) {
        token = JSON.parse(localStorage.getItem('token'));
    }

    if (token && token !== null) {
        return {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            Authorization: token,
        };
    } else {
        return {};
    }
}
